import * as yup from 'yup';

export const PaymentStepValidationSchema = yup.object().shape({});
